"use client";
import VertexLanding from "@/components/VertexLanding";

export default function Home() {
  return <VertexLanding />;
}
